// extracted by mini-css-extract-plugin
export var dropdownButton = "_2b-0";
export var fullWidthDropdownButton = "_2b-1";
export var icon = "_2b-3";
export var iconPlaceholder = "_2b-2";
export var shortcutContainer = "_2b-4";